import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=5db2e60a&scoped=true&"
import script from "./FAQ.vue?vue&type=script&lang=js&"
export * from "./FAQ.vue?vue&type=script&lang=js&"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=5db2e60a&lang=scss&scoped=true&"
import style1 from "./FAQ.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db2e60a",
  null
  
)

export default component.exports